import * as React from 'react'

interface IProgressBarProps {
  resultsConsumptionIsVisible: boolean
  resultsCaloriesAndCashIsVisible: boolean
  resultsStatisticsIsVisible: boolean
  riskCarrouselIsVisible: boolean
  resultsRepeatTestIsVisible: boolean
}

const ProgressBar: React.FC<IProgressBarProps> = ({
  resultsConsumptionIsVisible,
  resultsCaloriesAndCashIsVisible,
  resultsStatisticsIsVisible,
  riskCarrouselIsVisible,
  resultsRepeatTestIsVisible,
}) => {
  return (
    <div className="ProgressBar__container">
      <span
        className={`ProgressBar__row${
          resultsConsumptionIsVisible ||
          resultsCaloriesAndCashIsVisible ||
          resultsStatisticsIsVisible ||
          riskCarrouselIsVisible ||
          resultsRepeatTestIsVisible
            ? ' ProgressBar__row--rouge'
            : ' ProgressBar__row--creme'
        }`}
      />
      <span
        className={`ProgressBar__row${
          resultsCaloriesAndCashIsVisible ||
          resultsStatisticsIsVisible ||
          riskCarrouselIsVisible ||
          resultsRepeatTestIsVisible
            ? ' ProgressBar__row--rouge'
            : ' ProgressBar__row--creme'
        }`}
      >
        {resultsCaloriesAndCashIsVisible}
      </span>
      <span
        className={`ProgressBar__row${
          resultsStatisticsIsVisible || riskCarrouselIsVisible || resultsRepeatTestIsVisible
            ? ' ProgressBar__row--rouge'
            : ' ProgressBar__row--creme'
        }`}
      >
        {resultsStatisticsIsVisible}
      </span>
      <span
        className={`ProgressBar__row${
          riskCarrouselIsVisible || resultsRepeatTestIsVisible
            ? ' ProgressBar__row--rouge'
            : ' ProgressBar__row--creme'
        }`}
      >
        {riskCarrouselIsVisible}
      </span>
      <span
        className={`ProgressBar__row${
          resultsRepeatTestIsVisible ? ' ProgressBar__row--rouge' : ' ProgressBar__row--creme'
        }`}
      >
        {resultsRepeatTestIsVisible}
      </span>
    </div>
  )
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.tsx